import React from 'react'
import { Lightbulb, ShieldAlert } from 'lucide-react'
import { fmtCount, fmtPct } from './model'
import { partnerReason } from './reasons'

// One row for both channels. The rejection events carry no campaign, so
// they can't be split between API posts and form submissions; when the
// backend adds campaign_id to them, this can move into the two cards.
//
// Requests turned away before a lead existed: not part of the funnels
// above, which start at accepted leads.
export default function IntakeRejections({ intake }) {
  const reasons = intake.reasons || []
  const top = reasons[0] ? partnerReason(reasons[0].code) : null

  return (
    <section className="pw-card" aria-label="Rejected at intake" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <h2 className="pw-title" style={{ fontSize: 15, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
          <ShieldAlert size={16} aria-hidden="true" style={{ color: 'var(--text-muted)' }} />
          Rejected at intake (API + form submissions)
        </h2>
        <div className="pw-num" style={{ display: 'flex', gap: 18, fontSize: 12, color: 'var(--text-secondary)', flexWrap: 'wrap' }}>
          <span><strong style={{ color: 'var(--text-primary)' }}>{fmtCount(intake.submitted)}</strong> submitted</span>
          <span><strong style={{ color: 'var(--text-primary)' }}>{fmtPct(intake.accepted_rate_pct)}</strong> accepted</span>
          <span><strong style={{ color: 'var(--text-primary)' }}>{fmtCount(intake.rejected)}</strong> rejected</span>
        </div>
      </div>

      {reasons.length === 0 ? (
        <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>Nothing was rejected at intake in this period.</span>
      ) : (
        <>
          <ul aria-label="Why leads were rejected at intake" style={{ display: 'flex', flexWrap: 'wrap', gap: 8, margin: 0, padding: 0, listStyle: 'none' }}>
            {reasons.map((r) => {
              const meta = partnerReason(r.code)
              return (
                <li key={r.code} title={meta.detail} style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 12px',
                  borderRadius: 999, border: '1px solid var(--border)', background: 'var(--bg-raised)', fontSize: 12,
                }}>
                  <span aria-hidden="true" style={{ width: 8, height: 8, borderRadius: 999, background: meta.color }} />
                  <span style={{ color: 'var(--text-secondary)' }}>{meta.label}</span>
                  <strong className="pw-num" style={{ color: 'var(--text-primary)' }}>{fmtCount(r.count)}</strong>
                </li>
              )
            })}
          </ul>
          {/* The top reason explained in full, visible: a tooltip doesn't
              exist on a phone, and the top one is the one worth acting on. */}
          <p style={{ margin: 0, fontSize: 12, lineHeight: 1.5, color: 'var(--text-muted)' }}>
            <strong style={{ color: 'var(--text-secondary)' }}>{top.label}:</strong> {top.detail}
          </p>
          {reasons[0].code === 'consent_cert_missing' && (
            <div style={{
              display: 'flex', alignItems: 'flex-start', gap: 8, padding: '10px 12px',
              borderRadius: 'var(--radius)', background: 'var(--accent-soft)', color: 'var(--text-primary)',
              fontSize: 12, lineHeight: 1.5,
            }}>
              <Lightbulb size={14} aria-hidden="true" style={{ color: 'var(--accent)', flexShrink: 0, marginTop: 2 }} />
              <span>
                Most were missing a consent certificate. Sending the TrustedForm
                certificate URL with every lead will recover them.
              </span>
            </div>
          )}
        </>
      )}
    </section>
  )
}
